import isString from "lodash/isString";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";
import isObject from "lodash/isObject";

export default class Media {
  constructor(dto) {
    let m = this;
    m.bus = new ServiceBus();

    if (dto && isString(dto.payload)) dto.payload = JSON.parse(dto.payload);

    //properties
    m.status = "constructing";
    m.height = 0;
    m.width = 0;
    m.url = "";
    m.id = null; //int
    m.euid = null; //'guid'
    Object.assign(m, dto);
    m.imageUrls = {};
    if ($appConfig.isOffline && dto.url) {
      m.url = dto.url.replace(
        "https://emun-on-demand.s3.amazonaws.com",
        `${$appConfig.serviceUrl}s3/emun-on-demand`
      );
      // console.debug("Media", dto.url, { m, dto });
    }
    for (var k in m.images || {}) m.imageUrls[k] = m.getUrl(m.images[k]);
  }

  static getUrl(url, slug) {
    // console.debug('static getUrl', url, slug);
    return (
      url && url.replace(/[^\/]*$/, slug || "small.png")
      // .replace(
      //   "http://emun-on-demand.s3-website-us-east-1.",
      //   "https://emun-on-demand.s3."
      // )
    );
  }

  load() {}

  save() {}

  renderingImage(size) {
    return $appConfig.renderingImage(this.id, size);
  }

  getExtension() {
    if (!this || !this.url) return null;
    let splat = this.url.split(".");
    return splat[splat.length - 1];
  }

  isAudio() {
    return this.contentType && this.contentType.startsWith("audio");
  }

  isVideo() {
    return this.contentType && this.contentType.startsWith("video");
  }

  isImage() {
    return this.contentType && this.contentType.startsWith("image");
  }

  isBitmap() {
    return (
      this.contentType &&
      this.contentType.startsWith("image") &&
      this.contentType.indexOf("svg") === -1
    );
  }

  isDesign() {
    return this.url.endsWith("design.json");
  }

  isSvg() {
    return (
      this.contentType &&
      this.contentType.startsWith("image/svg") &&
      this.url.endsWith("svg")
    );
  }

  isPdf() {
    return this.contentType.endsWith("/pdf");
  }

  getIcon(type) {
    let ext = this.getExtension();
    type = type || this.contentType || ext;
    if (/(image|svg|jpg|png|gif|jpeg)/i.test(type)) return "file-image-o";
    if (/(psd)/i.test(ext)) return "picture-o";
    if (/(psd)/i.test(type)) return "picture-o";
    if (/(pdf)/i.test(type)) return "file-pdf-o";
    if (/(text|txt|log)/i.test(ext)) return "file-text-o";
    if (/(text|txt|log)/i.test(type)) return "file-text-o";
    if (/(json|html|xml)/i.test(ext)) return "file-code-o";
    if (/(json|html|xml)/i.test(type)) return "file-code-o";
    if (/(xls|csv)/i.test(ext)) return "file-excel-o";
    if (/(xls|csv)/i.test(type)) return "file-excel-o";
    if (/(doc)/i.test(ext)) return "file-word-o";
    if (/(doc)/i.test(type)) return "file-word-o";
    if (/(ppt)/i.test(ext)) return "file-powerpoint-o";
    if (/(ppt)/i.test(type)) return "file-powerpoint-o";
    if (/(video|mp4|mov|m4v)/i.test(ext)) return "file-video-o";
    if (/(video|mp4|mov|m4v)/i.test(type)) return "file-video-o";
    if (/(audio|mp3)/i.test(ext)) return "file-audio-o";
    if (/(audio|mp3)/i.test(type)) return "file-audio-o";
    return "file-o";
  }

  getUrl(slug = "small.png") {
    if (
      !$appConfig.isOffline &&
      this.isBitmap() &&
      this.url.indexOf("emun-on-demand") > 0
    ) {
      const url = new URL(this.url);
      const args = {
        bucket: "emun-on-demand", //url.hostname.split('/')[0]
        key: url.pathname.substring(1),
        edits: {
          // resize: { width: size, height: size, fit: "inside" },
        },
      };
      if (isString(slug)) {
        const size = slug.startsWith("thumbnail")
          ? 150
          : slug.startsWith("small")
          ? 300
          : slug.startsWith("medium")
          ? 768
          : slug.startsWith("large")
          ? 1500
          : slug.startsWith("xl")
          ? 1920
          : slug.startsWith("4k")
          ? 3840
          : 1024;
        args.edits.resize = { width: size, height: size, fit: "inside" };
      } else if (isObject(slug)) {
        // https://docs.aws.amazon.com/solutions/latest/serverless-image-handler/deployment.html#step2
        // https://aws.amazon.com/blogs/architecture/fast-and-cost-effective-image-manipulation-with-serverless-image-handler/
        args.edits = slug;
      }

      return `https://d39vqfq6hb7tje.cloudfront.net/${btoa(
        JSON.stringify(args)
      )}`;
    }
    //const url = slug.endsWith('.json') ? this.url.replace('http://emun-on-demand.s3-website-us-east-1.', 'https://emun-on-demand.s3.') : this.url;
    return Media.getUrl(this.url, slug);
  }

  designUrl() {
    // console.debug('designUrl', this.url);
    return (
      this.url.endsWith(".json") ? this.url : this.getUrl("design.json")
    ).replace(
      "http://emun-on-demand.s3-website-us-east-1.",
      "https://emun-on-demand.s3."
    );
  }

  img(size = "small", ext = "png") {
    if (isObject(size)) {
      return this.getUrl(size);
    }
    return this.getUrl(size + "." + ext);
  }

  defaultImage() {
    const m = this;
    if (m.realm.startsWith("Design") || m.realm.startsWith("Clipart"))
      return m.getUrl("small.png");
  }
}
